import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';

import messages from './messagesFareRulesMatrixContent';
import inlineStyles from './fareRulesMatrixContentStyles';

const FareTerminals = ({
    fareTerminals,
}) => (fareTerminals && (
    <>
        <FormattedMessage {...messages.lblFareTerminalsValidityText} />
        <br />
        {fareTerminals.replace(/ *\([^)]*\) */g, '')}
    </>
)) || '';

FareTerminals.propTypes = {
    intl: PropTypes.object,
    fareTerminals: PropTypes.string,
};

export { FareTerminals as FareTerminalsAlias };
export default withStyles(inlineStyles)(FareTerminals);
